export const isErrorCode = (error) => {
  return error && !Number.isNaN(Number.parseInt(error, 10));
};

export const checkErrorStatus = ({ pristine, touched, error, active, submitFailed, valid }) => {
  return (!pristine && touched && error && !active) || (submitFailed && error && !valid && !active && touched);
};

export const checkSyncedErrorStatus = ({ pristine, error, submitFailed, valid }) => {
  return (!pristine && error) || (submitFailed && error && !valid);
};

export const checkImmediateErrorStatus = ({ error, submitFailed, valid }) => {
  return !!error || (submitFailed && error && !valid);
};
